const JAPAN_LOCALE_STRING = 'jp';
const JAPAN_SITE_LIVE_URL = 'https://www.bloomberg.co.jp/live';
const DEFAULT_LIVE_URL = '/live';

export { default as labelIds } from './label_ids.json';
export const contextId = 4713;

export function getLiveUrl(locale?: string): string {
  if (locale === JAPAN_LOCALE_STRING) {
    return JAPAN_SITE_LIVE_URL;
  }

  return DEFAULT_LIVE_URL;
}
